module.exports = __webpack_public_path__ + "static/media/akp-cover.aa585660.jpg";